import {Fragment} from "react";

function TamponOverview({lines, roundLines, selectedTampon, encreCouleur, contour, selectedImage, motif})
{

    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    today = dd + '/' + mm + '/' + yyyy;

    function circlePath( rayon, sens, offset){
        if(!sens)
            return 'M '+rayon+ ' ' + ((rayon*2)-offset) +' A ' +(rayon-offset)+' '+(rayon-offset)+' 0 1 1 '+(rayon+1)+' '+((rayon*2)-offset);
        else
            return 'M '+rayon+ ' '+  (0+offset)+ ' A ' +(rayon-offset)+' '+(rayon-offset)+' 0 1 0 '+(rayon+1)+' '+(0+offset) ;
    }


    return (
        <svg
            style={{
                "width": 3.78*selectedTampon.dimensions.width+'px',
                "height": 3.78*selectedTampon.dimensions.height+'px',
            }}
        >

            <style type="text/css"
                   dangerouslySetInnerHTML={{__html: "@font-face {font-family: Arcade;src: url(https://tamporexlaser.com/wp-content/themes/TamporexLaser/font/Arcade.ttf);}" +
                           "                          @font-face {font-family: Arial Condensed;src: url(https://tamporexlaser.com/wp-content/themes/TamporexLaser/font/Arialn.TTF);}" +
                           "                          @font-face {font-family: Brush;src: url(https://tamporexlaser.com/wp-content/themes/TamporexLaser/font/brushscn.TTF);}" +
                           "                          @font-face {font-family: Century;src: url(https://tamporexlaser.com/wp-content/themes/TamporexLaser/font/censbkb.TTF);}" +
                           "                          @font-face {font-family: Cheltenham;src: url(https://tamporexlaser.com/wp-content/themes/TamporexLaser/font/chltboc.TTF);}" +
                           "                          @font-face {font-family: Cheltenham Bold; src: url(https://tamporexlaser.com/wp-content/themes/TamporexLaser/font/chltboa.TTF);}" +
                           "                          @font-face {font-family: Comic;src: url(https://tamporexlaser.com/wp-content/themes/TamporexLaser/font/comic.TTF);}" +
                           "                          @font-face {font-family: Diskus;src: url(https://tamporexlaser.com/wp-content/themes/TamporexLaser/font/diskusm.TTF);}" +
                           "                          @font-face {font-family: Tahoma;src: url(https://tamporexlaser.com/wp-content/themes/TamporexLaser/font/tahoma.ttf);}"}
                   } />
            {
                motif !== null &&
                <image
                    href={motif.url}
                    preserveAspectRatio="none"
                    x={motif.x}
                    y={motif.y}
                    width={motif.width}
                    ratio="0.99"
                    transform="matrix(1,0,0,1,0,0)"
                ></image>
            }


            {
                (selectedTampon && selectedTampon.forme === 'ronde') &&
                roundLines.map((line, idx) => {
                    return (
                        <text
                            id="text_0"
                            className="text_rond"
                            key={"apercu-round-line-" + idx}
                            style={{
                                "fontSize": line.fontSize + 'px',
                                "fontFamily": line.fontFamily,
                                "textAnchor": "middle",
                                "fontWeight": line.bold ? 'bold': 'normal',
                                "fontStyle": line.italic ? 'italic': 'normal',
                                "textDecoration": line.underline ? 'underline': 'none',
                                "transform-origin": "50% 50%",
                                "transform": "rotate("+line.rotation+"deg)",
                                "fill": encreCouleur === 'bleu' ? '#0000ff' : (encreCouleur === 'rouge' ? '#ff0000' : '#000000')
                            }}
                            line-height={line.lineHeight}
                        >
                            <textPath
                                href={"#pathRoundLine"+idx}
                                startOffset="50%"
                                offset_angle="0"
                            >
                                <tspan
                                    style={{
                                        'letterSpacing': line.letterSpacing + 'px',
                                        "textDecoration": line.underline ? 'underline': 'none',
                                    }}>{line.text}</tspan>
                            </textPath>
                        </text>
                    )
                })
            }

            <defs>
                {
                    (selectedTampon && selectedTampon.forme === 'ronde') &&
                    roundLines.map((line, idx) => {
                        return (
                            <path
                                key={"def-"+idx}
                                d={circlePath(selectedTampon.dimensions.width*3.78 / 2, idx, line.offset)}
                                id={"pathRoundLine"+idx}
                            ></path>
                        )
                    })
                }
            </defs>

            {
                lines.map((line, idx) => {
                    return (
                        <text
                            x={line.positions.x}
                            y={line.positions.y}
                            key={"apercu-line-" + idx}
                            line-height={line.lineHeight}
                            style={{
                                "fontSize": line.fontSize + 'px',
                                "fontFamily": line.fontFamily,
                                "textAnchor": line.textAnchor,
                                "fontWeight": line.bold ? 'bold': 'normal',
                                "fontStyle": line.italic ? 'italic': 'normal',
                                "textDecoration": line.underline ? 'underline': 'none',
                                "fill": encreCouleur === 'bleu' ? '#0000ff' : (encreCouleur === 'rouge' ? '#ff0000' : '#000000')
                            }}
                            transform="matrix(1,0,0,1,0,0)"
                        >{line.text}</text>
                    )
                })
            }

            {
                selectedImage &&
                <image
                    href={selectedImage.url}
                    preserveAspectRatio="none"
                    x={selectedImage.x}
                    y={selectedImage.y}
                    width={selectedImage.width}
                    ratio="1.00"
                    transform="matrix(1,0,0,1,0,0)"
                ></image>

            }

            {
                (selectedTampon.dateur === true) &&
                <>
                    <rect
                        x={3.78 * selectedTampon.dimensions.width / 2 - 60}
                        y={3.78 * selectedTampon.dimensions.height / 2 - 20}
                        width="120"
                        height="40"
                        fill="rgba(0,0,0,0.1)"
                        stroke="rgba(0,0,0,0)"
                        style={{
                            "strokeWidth": 0.5
                        }}
                    ></rect>
                    <text
                        x={(3.78 * selectedTampon.dimensions.width / 2) - 53}
                        y={(3.78 * selectedTampon.dimensions.height / 2) + 6}
                        border="red"
                        style={{
                            fontSize: "23px",
                        }}
                        fill="#000000"
                    >{today}</text>
                </>
            }

            {
                (selectedTampon.forme === 'rectangle' || selectedTampon.forme === 'carree') &&
                <rect
                    x="1"
                    y="1"
                    width={3.78*selectedTampon.dimensions.width - 2 }
                    height={3.78*selectedTampon.dimensions.height - 2 }
                    fill="rgba(0,0,0,0)"
                    stroke={contour === 'sans' ? 'red' : (encreCouleur === 'bleu' ? '#0000ff' : (encreCouleur === 'rouge' ? '#ff0000' : '#000000'))}
                    style={{
                        "strokeWidth": contour === 'double' ? '2mm' : (contour === 'simple' ? '1mm' : '1px'),
                        "strokeDasharray": contour == 'sans' ? '4px' : '0'
                    }}
                ></rect>
            }

            {
                selectedTampon.forme === 'ronde' &&
                <circle
                    cx={3.78 * selectedTampon.dimensions.width / 2}
                    cy={3.78 * selectedTampon.dimensions.width / 2}
                    r={3.78 * selectedTampon.dimensions.width / 2 - (contour === 'double' ? (2*3.78) : (contour === 'simple' ? 3.78 : 2)) / 2}
                    fill="rgba(0,0,0,0)"
                    stroke={contour === 'sans' ? 'red' : (encreCouleur === 'bleu' ? '#0000ff' : (encreCouleur === 'rouge' ? '#ff0000' : '#000000'))}
                    style={{
                        "strokeWidth": contour === 'double' ? '2mm' : (contour === 'simple' ? '1mm' : '1px'),
                        "strokeDasharray": contour == 'sans' ? '4px' : '0'
                    }}
                ></circle>
            }

            {
                selectedTampon.forme === 'ovale' &&
                <ellipse
                    cx={3.78 * selectedTampon.dimensions.width / 2}
                    cy={3.78 * selectedTampon.dimensions.height / 2}
                    rx={3.78 * selectedTampon.dimensions.width / 2 - (contour === 'double' ? (2*3.78) : (contour === 'simple' ? 3.78 : 2)) / 2}
                    ry={3.78 * selectedTampon.dimensions.height / 2 - (contour === 'double' ? (2*3.78) : (contour === 'simple' ? 3.78 : 2)) / 2}
                    fill="rgba(0,0,0,0)"
                    stroke={contour === 'sans' ? 'red' : (encreCouleur === 'bleu' ? '#0000ff' : (encreCouleur === 'rouge' ? '#ff0000' : '#000000'))}
                    style={{
                        "strokeWidth": contour === 'double' ? '2mm' : (contour === 'simple' ? '1mm' : '1px'),
                        "strokeDasharray": contour == 'sans' ? '4px' : '0'
                    }}
                ></ellipse>
            }

        </svg>
    );
}

export default TamponOverview;

